var deleteUndefinedOrNull = function(object) {
	var out = {};
	for(var i in object) {
		if(object[i] !== undefined && object[i] !== null) {
			out[i] = object[i];
		}
	}
	return out;
};

var transitionEndEvent = (function () {
	var t;
    var el = document.createElement('element');
    var transitions = {
      'transition':'transitionend',
      'OTransition':'oTransitionEnd',
      'MozTransition':'transitionend',
      'WebkitTransition':'webkitTransitionEnd'
    }

    for(t in transitions) {
        if(el.style[t] !== undefined){
            return transitions[t];
        }
    }
}());

var onAnimationEnd = function($els, callback) {
	var $el;
	var toTrigger = $els.length;
	
	var queueCallback = function(event) {
		$(this).off(transitionEndEvent, queueCallback);
		toTrigger--;
		if(toTrigger == 0) {
			callback();
		}
	};
	
	if(transitionEndEvent) {
		for(var i = 0, s = $els.length; i < s; ++i) {
			$el = $($els[i]);
			$el.on(transitionEndEvent, queueCallback);
		}
	} else {
		callback();
	}
};

var runSliders = function($sliders, filterData, changeCallback) {
	var prepareRange = function(options) {
		var out = {};
		var all = options.length-1;
		var step = ~~Math.round(100/all);
		
		out.min = parseFloat(options[0]);
		out.max = parseFloat(options[all]);
		
		for(var i = 1; i < all; ++i) {
			out[step*i+'%'] = options[i];
		}
		return out;
	};
	//var $sliders = $('.investments-filters .filter-slider');
	var slider;
	var $slider;
	var options;
	var $min;
	var $max;
	var addon;
	var range;
	var name;
	for(var i = 0, s = $sliders.length; i < s; ++i) {
		$container = $($sliders[i]);
		$slider = $container.find('.filter-slider__slider');
		$min = $container.find('.filter-slider__value-min');
		$max = $container.find('.filter-slider__value-max');
		addon = $container.data('addon');
		name = $container.data('name');
		if(!addon) {
			addon = '';
		}
		slider = $slider.get(0);
		
		options = $container.data('options');
		if(options.length == 0) {
			$slider.hide();
		} else if(options.length == 1) {
			$min.html(options[0].toString().replace('.', ',')+addon);
			$max.html(options[0].toString().replace('.', ',')+addon);
			noUiSlider.create(slider, {
				start: [0, 1],
				connect: true,
				range: {min: 0, max: 1},
				snap: true
			});
			slider.setAttribute('disabled', true);
		}
		else {
			
			range = prepareRange(options);
			noUiSlider.create(slider, {
				start: [options[0], options[options.length-1]],
				connect: true,
				range: range,
				snap: true
			});
			
			$min.html(range.min.toString().replace('.', ',')+addon);
			$max.html(range.max.toString().replace('.', ',')+addon);
			
			slider.noUiSlider.on('update', function ($min, $max, addon, range, name, values, handle, unencoded, isTap, positions) {
				var min = parseFloat(values[0]);
				var max = parseFloat(values[1]);
				
				var changed = false;
				
				$min.html(min.toString().replace('.', ',')+addon);
				$max.html(max.toString().replace('.', ',')+addon);
			}.bind(slider.noUiSlider, $min, $max, addon, range, name));
			
			slider.noUiSlider.on('change', function ($min, $max, addon, range, name, values, handle, unencoded, isTap, positions) {
				var min = parseFloat(values[0]);
				var max = parseFloat(values[1]);
				
				var changed = false;
				
				if(min === range.min && max === range.max) {
					if(filterData[name]) {
						delete(filterData[name]);
						changed = true;
					}
				} else {
					if(!filterData[name] || min !== filterData[name].from || max !== filterData[name].to) {
						changed = true;
						filterData[name] = {
							from: min,
							to: max
						};
					}
				}
				
				if(true === changed && changeCallback) {
					changeCallback();
				}
			}.bind(slider.noUiSlider, $min, $max, addon, range, name));
		}
	}
};